import React from 'react'
import logo from '../assets/img/logo.jpg'
import InviteBotButton from './InviteBotButton'
import './Header.css'

function Header() {
  return (
    <header className="header" role="banner">
      <div className="header-container">
        <div className="logo" itemScope itemType="https://schema.org/Organization">
          <img
            src={logo}
            alt=""
            className="logo-img"
            width={40}
            height={40}
            aria-hidden="true"
          />
          <span className="logo-text" itemProp="name">Pokefarm</span>
        </div>
        <nav className="nav" role="navigation" aria-label="Navigation principale">
          <a href="#installation" className="nav-link">Installation</a>
          <a href="#comment-jouer" className="nav-link">Comment jouer</a>
          <a href="#features" className="nav-link">Fonctionnalités</a>
          <a href="#evolution" className="nav-link">Évolutions</a>
        </nav>
        <InviteBotButton className="cta-button">
          Ajouter le bot
        </InviteBotButton>
      </div>
    </header>
  )
}

export default Header
